import { RFM } from "../../constants/action-types";
const initialState = {
    groupedRFMMatrix: [],
    monetaryDataTable: [],
    avgAmountByMscore: [],
    avgDaysSinceByR: [],
    recencyDataTable: [],
    avgPurchaseByFScore: [],
    frequencyDataTable: [],
    oneTimeVsRepeat: [],
    totalSpendByMonetaryScore: []
}

const RFMReducer = (state = initialState, action) => {
    switch (action.type) {
        case RFM.UPDATE_TOTAL_SPEND_BY_MONETARY_SCORE_DATA: {
            return Object.assign({}, state, {
                totalSpendByMonetaryScore: action.payload
            });

        }
        case RFM.UPDATE_ONE_TIME_VS_REPEAT_DATA: {
            return Object.assign({}, state, {
                oneTimeVsRepeat: action.payload
            });

        }
        case RFM.UPDATE_FREQUENCY_BAR_DATA: {
            return Object.assign({}, state, {
                avgPurchaseByFScore: action.payload
            });

        }
        case RFM.UPDATE_FREQUENCY_TABLE_DATA: {
            return Object.assign({}, state, {
                frequencyDataTable: action.payload
            });

        }
        case RFM.UPDATE_RECENCY_BAR_DATA: {
            return Object.assign({}, state, {
                avgDaysSinceByR: action.payload
            });

        }
        case RFM.UPDATE_RECENCY_TABLE_DATA: {
            return Object.assign({}, state, {
                recencyDataTable: action.payload
            });

        }
        case RFM.UPDATE_GROUPED_RFM_MATRIX_DATA: {
            return Object.assign({}, state, {
                groupedRFMMatrix: action.payload
            });

        }
        case RFM.UPDATE_MONETARY_TABLE_DATA: {
            return Object.assign({}, state, {
                monetaryDataTable: action.payload
            });

        }
        case RFM.UPDATE_MONETARY_BAR_DATA: {
            return Object.assign({}, state, {
                avgAmountByMscore: action.payload
            });

        }

        default:
            return state
    }

}

export default RFMReducer